
    import '/home/ec2-user/Youlify-Design/components/switch/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["switch-demo-basic","switch-demo-disabled","switch-demo-text","switch-demo-size","switch-demo-loading","switch-demo-component-token"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/home/ec2-user/Youlify-Design/components/switch/index.zh-CN.md?type=demo')
};